
import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator';
import {
  ISanityDocuments,
  SanityDocumentSchema,
  ProjectPageVariation,
} from '~/types/sanity-documents';

@Component
export default class ProjectTimeline extends Vue {
  @Prop({ type: Number, default: 0 })
  readonly currentStep!: number;
  @Prop(String) readonly id!: string;

  schemas = SanityDocumentSchema;
  panel: number[] = [];
  variations = ProjectPageVariation;

  @Watch('currentStep', { immediate: true })
  handleCurrentStepChange(current: number | undefined) {
    if (current) {
      this.panel?.push(current - 1);
    }
  }

  async fetch() {
    if (this.id) {
      this.$sanityLookup.fetchDocument({
        _id: this.id,
        _type: this.schemas.TIMELINE,
        fetchReferences: true,
      });
    }
  }

  get variation() {
    return this.$sanityLookup.getSiteConfig()?.data?.projectPageVariation;
  }

  get docState() {
    return (
      this.$sanityLookup.getDocumentFromId<
        ISanityDocuments[SanityDocumentSchema.TIMELINE]
      >({
        _id: this.id,
        _type: this.schemas.TIMELINE,
      }) || {
        hasError: false,
        isLoading: false,
      }
    );
  }

  get steps() {
    return this.docState?.data?.timelinePeriods || [];
  }

  get title() {
    return (
      this.docState?.data?.title ||
      this.$t('components.films.filmInfoTabs.timeline')
    );
  }

  @Watch('docState.data', { immediate: true })
  handleDocChange(
    current: ISanityDocuments[SanityDocumentSchema.TIMELINE] | undefined,
  ) {
    if (!current) {
      return;
    }

    const refs = this.$sanityLookup.getDocumentRefIds(current);
    if (refs) {
      this.$sanityLookup.fetchReference({
        _id: Object.keys(refs),
      });
    }
  }
}
